import { render, staticRenderFns } from "./InvestorIncomeDialog.vue?vue&type=template&id=413949a4&scoped=true&lang=pug&"
import script from "./InvestorIncomeDialog.vue?vue&type=script&lang=ts&"
export * from "./InvestorIncomeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InvestorIncomeDialog.vue?vue&type=style&index=0&id=413949a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413949a4",
  null
  
)

export default component.exports